<template>
	<div class="media widthz">
		<div class="navGo flex ">
			<span @click="goHomg()">首页></span>
			<span>详情</span>
		</div>

		<section class="widthWhite lu_bo flex float">
			<div class="video_div zhan" style="position: relative;">
				<video width="320" height="500" ref="video" :src="currItem.Video" controls>
					<!-- <source :src="currItem.Video" type="video/mp4" />
					<source :src="currItem.Video" type="video/ogg" />
					您的浏览器不支持 video 标签。 -->
				</video>
				<img src="../../image/san/yaa.png" :style="{ transform: isOpen ? 'rotate(0deg)' : '' }" class="videoDing" @click="isOpen = !isOpen" />
			</div>
			<!-- <div class="video_div zhan" style="position: relative;" v-else>
				<img src="../../image/banner.png" class="video_img" />
				<p class="shl">{{currItem.Name}}</p>
				<img src="../../image/san/yaa.png" :style="{'transform':isOpen?'rotate(0deg)':''}" class="videoDing"
					@click="isOpen = !isOpen" />
			</div> -->

			<!-- right -->
			<div class="right" v-if="isOpen">
				<p>共{{ classList.length }}讲</p>
				<ul style="height: calc( 100% - 35px ); overflow: auto;">
					<li
						class="flex float"
						:style="{ 'background-color': currItem.Id == item.Id ? '#f5f5f5' : '' }"
						v-for="(item, index) in classList"
						:key="index"
						v-on:click="playItem(item)"
					>
						<div class="li_img"><img :src="item.CoverStr" /></div>
						<div class="li_hg">
							<h2 class="shlTwo">{{ item.Name }}</h2>
							<div class="flexFloat">
								<p>
									<i></i>
									{{ item.Time }}
								</p>
								<p>
									<i></i>
									{{ item.WatchNumber + item.RealWatchNumber }}
								</p>
							</div>
						</div>
					</li>
				</ul>
			</div>
		</section>

		<section class="widthWhite" style="padding-top: 20px;">
			<div class="pj-tit flexFloat">
				<p>{{ detail.Name }}</p>
				<div class="flex zhong">
					<div class="pj-num">
						<img src="../../image/zs_see.png" />
						<span>{{ detail.WatchNumber + detail.RealWatchNumber }}</span>
					</div>
					<div class="fg_div flex zhong">
						<img :src="detail.UserAttention ? require('../../image/san/wxbba.png') : require('../../image/san/wxb.png')" v-on:click="AttentionAdd" />
						<img src="../../image/san/wxa.png" @click="isPOP = true" />
					</div>
				</div>
			</div>
			<h6>介绍</h6>
			<article class="details_nei fwbhtml" v-html="detail.Profit"><!-- {{detail.Profit}} --></article>
		</section>

		<!-- pop -->
		<aside class="popup flexCenter" v-if="isPOP">
			<div class="bai">
				<p class="baia">分享到微信朋友圈</p>
				<div class="bai_img">
					<!-- <img src="../../image/banner.png" /> -->
					<vue-qr :value="shareUrl" :options="{ size: 190 }"></vue-qr>
				</div>
				<p class="baib">打开微信，点击底部的"发现"</p>
				<p class="baib">使用"扫一扫"即可将网页分享至朋友圈</p>
				<button type="button" class="btn" @click="isPOP = false">关闭</button>
			</div>
		</aside>

		<!-- vip -->
		<aside class="popup flexCenter" v-if="isVip">
			<div class="vip_bai">
				<img src="../../image/san/va.png" />
				<p>该内容仅VIP观看</p>
				<div class="vip_btn flexCenter">
					<button type="button" @click="closeShow">关闭</button>
					<button type="button" @click="vipTo()">开通VIP卡</button>
				</div>
			</div>
		</aside>
	</div>
</template>
<script>
import vueQr from '@xkeshi/vue-qrcode';
import QRCode from 'qrcodejs2'
export default {
	name: 'media',
	data() {
		return {
			isOpen: true,
			isVideo: false,
			isPOP: false,
			detailId: 0,
			detail: {},
			isVip: false,
			jiangList: [],
			shareUrl: '',
			userInfo: {},
			classList: [],
			currItem: {}
		};
	},
	components: {
		vueQr
	}, 
	mounted() {
		console.log('页面传参' + this.$route.query);
		this.detailId = this.$route.query.Id ? this.$route.query.Id : 0;
		this.shareUrl = 'https://'+window.location.host  + '/mobile/#/luboxq?Id=' + this.detailId;
		console.log('shareUrl', this.shareUrl);
		this.GetUserInfo();
	},
	methods: {
		closeShow: function() {
			this.$router.go(-1);
		},
		vipTo() {
			this.$router.push('/vip');
			this.isVip = false;
		},
		// 返回首页
		goHomg() {
			this.$router.push('/home');
		},
		playItem: function(item) {
			var that = this;
			that.classList.forEach(a => {
				if (a.Id === item.Id) {
					a.isPlay = true;
				} else {
					a.isPlay = false;
				}
			});
			that.currItem = item;
			that.$refs.video.play();
		},
		// 获取详情
		GetDetail: function() {
			var that = this;
			const loading = this.$loading({
				lock: true
			});
			that.$api.HtppRequest(
				'WebsiteSet/GetClassroomDetail?Id=' + that.detailId,
				'GET',
				{},
				function(res) {
					console.log('获取详情');
					console.log(res);
					if (res.code === 0) {
						that.detail = res.data;
						if (!that.detail.IsVIP) {
							that.isVip = false;
						} else {
							that.isVip = !that.userInfo.IsVip;
						}
						var newList = [];
						var index = 0;
						that.detail.CourseList.map(a => {
							index++;
							newList.push({
								ClassroomId: a.ClassroomId,
								Cover: a.Cover,
								CoverStr: a.CoverStr,
								Enable: a.Enable,
								H5Cover: a.H5Cover,
								H5CoverStr: a.H5CoverStr,
								Id: a.Id,
								Name: a.Name,
								RealWatchNumber: a.RealWatchNumber,
								Sort: a.Sort,
								Time: a.Time,
								Video: a.Video,
								WatchNumber: a.WatchNumber,
								isPlay: index === 1
							});
						});
						that.classList = newList;
						that.currItem = newList.length > 0 ? newList[0] : {};
						that.isOpen = that.classList.length > 1;
						console.log('that.currItem', that.currItem);
					}
					loading.close();
				},
				function(res) {
					loading.close();
				}
			);
		},
		// 添加或取消关注
		AttentionAdd: function() {
			var that = this;
			// ContentId 院校/专业数据Id 课程Id/文章Id
			// Type 1=院校 2=专业 3=课程 4=文章
			that.$api.HtppRequest(
				'Accurate/AttentionAdd?UserId=' + that.userInfo.Id + '&ContentId=' + this.detailId + '&Type=3',
				'GET',
				{},
				function(res) {
					console.log('添加或取消关注');
					console.log(res);
					if (res.code === 0) {
						that.newsTitle = res.data;
						that.detail.UserAttention = !that.detail.UserAttention;
						that.$util.showOk(res.msg);
					} else {
						that.$util.showError(res.msg);
					}
				},
				function(res) {}
			);
		},
		// 获取用户信息
		GetUserInfo: function() {
			var that = this;
			that.$api.HtppRequest(
				'User',
				'GET',
				{},
				function(res) {
					console.log('获取用户信息');
					console.log(res);
					if (res.code === 0) {
						that.userInfo = res.data;
						// that.isVip=!res.data.IsVip;
					}
					that.GetDetail();
				},
				function(res) {}
			);
		}
	}
};
</script>
<style scoped>
.right ul::-webkit-scrollbar {
	width: 2px;
	height: 2px;
	color: #999;
}

.li_hg p {
	font-size: 14px;
	color: #888889;
	display: flex;
	align-items: center;
}

.li_hg p i {
	display: block;
	width: 16px;
	height: 16px;
	background: url(../../image/zs_time.png) no-repeat left top;
	background-size: 100% 100%;
}

.li_hg p:last-child i {
	background: url(../../image/zs_see.png) no-repeat left top;
	background-size: 100% 100%;
}

.li_hg h2 {
	font-weight: normal;
	font-size: 14px;
	height: 42px;
	margin-bottom: 15px;
	color: #000;
}

.li_hg {
	width: calc(100% - 130px);
}

.li_img img {
	display: block;
	width: 100%;
	height: 100%;
	object-fit: cover;
}

.li_img {
	border-radius: 4px;
	width: 120px;
	height: 80px;
	overflow: hidden;
	background: url(../../image/nob.png) no-repeat left top;
	background-size: 100% 100%;
}

.right li {
	padding: 10px 30px;
}

.right > p {
	padding-left: 20px;
	height: 35px;
	font-size: 14px;
	color: #000;
	line-height: 35px;
}

.videoDing {
	width: 40px;
	height: 40px;
	position: absolute;
	right: -20px;
	top: 50%;
	margin-top: -20px;
	z-index: 2;
	cursor: pointer;
	transform: rotate(180deg);
}

.videoDing:hover {
	opacity: 0.7;
}

.right {
	width: 340px;
	overflow: hidden;
	height: 500px;
	border: solid 1px #f5f5f5;
}

.video_div p {
	background-color: rgba(0, 0, 0, 0.4);
	width: 100%;
	height: 55px;
	line-height: 55px;
	padding: 0 15px;
	box-sizing: border-box;
	position: absolute;
	left: 0;
	font-size: 14px;
	color: #fff;
	bottom: 0;
	z-index: 2;
}

.video_div img.video_img {
	display: block;
	width: 100%;
	height: 100%;
	object-fit: cover;
}

.video_div {
	flex: 1;
	height: 500px;
	position: relative;
	transition: all 0.3s ease;
}

.vip_btn button:last-child {
	background: linear-gradient(to right, #ffaf19, #ff7b04);
}

.vip_btn button {
	margin: 0 20px;
	width: 200px;
	height: 40px;
	border-radius: 4px;
	background-color: #444444;
	font-size: 14px;
	color: #fff;
	text-align: center;
	line-height: 40px;
	cursor: pointer;
}

.vip_bai p {
	text-align: center;
	margin-top: 20px;
	font-size: 14px;
	color: #000;
	margin-bottom: 70px;
}

.vip_bai img {
	display: block;
	width: 124px;
	height: 124px;
	margin: 0 auto;
}

.vip_bai {
	width: 516px;
	border-radius: 6px;
	background-color: #fff;
	padding: 50px 0;
}

/* vip_bai */

.btn {
	width: 200px;
	height: 40px;
	border-radius: 6px;
	font-size: 14px;
	display: block;
	margin: 40px auto 0 auto;
	color: #fff;
	text-align: center;
	line-height: 40px;
	background-color: #444444;
	cursor: pointer;
}

.baib {
	text-align: center;
	font-size: 14px;
	color: #666666;
}

.bai_img img {
	display: block;
	width: 100%;
	height: 100%;
}

.bai_img {
	width: 190px;
	height: 190px;
	padding: 15px;
	background-color: #fafafa;
	margin: 25px auto;
}

.baia {
	text-align: center;
	font-size: 14px;
	color: #000;
}

.bai {
	border-radius: 10px;
	width: 515px;
	background-color: #fff;
	padding: 20px 0;
}

.fg_div img {
	display: block;
	width: 32px;
	height: 32px;
	margin-left: 20px;
	cursor: pointer;
}

/* 2.13 */
.details_nei >>> img {
	display: block;
	width: 100%;
}

.widthWhite h6 {
	font-size: 16px;
	color: #333;
	padding-left: 10px;
	position: relative;
	font-weight: normal;
	margin-bottom: 30px;
}

.widthWhite h6::after {
	content: '';
	width: 4px;
	height: 16px;
	border-radius: 50px;
	background-color: #444444;
	position: absolute;
	left: 0;
	top: 50%;
	margin-top: -8px;
	z-index: 1;
}

.pj-tit {
	padding-bottom: 20px;
	width: 100%;
	border-bottom: solid 1px #f5f5f5;
	margin-bottom: 20px;
}

.pj-tit p {
	width: 60%;
	font-size: 16px;
	color: #333;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: normal;
	font-weight: bold;
}

.pj-num {
	width: 40%;
	display: flex;
	align-items: center;
	justify-content: flex-end;
}

.pj-num img {
	width: 24px;
	height: 24px;
	display: block;
}

.pj-num span {
	font-size: 12px;
	color: #666;
}

.video_div video {
	width: 100%;
	height: 500px;
	overflow: hidden;
	display: block;
}

.lu_bo {
	margin-bottom: 30px;
}

.details_nei {
	font-size: 14px;
}

.widthWhite hgroup p span {
	margin: 0 20px;
}

.widthWhite hgroup p {
	margin-top: 20px;
	font-size: 12px;
	color: #666;
}

.widthWhite hgroup h6 {
	font-weight: normal;
	font-size: 16px;
	text-align: center;
}

.widthWhite hgroup {
	padding: 0 0 20px 0;
	margin-bottom: 20px;
	border-bottom: solid 1px #e6e6e6;
}
</style>
